import { useCurrentStep } from './_atoms/draftReport/useCurrentStep';
import type { ReportStep } from './ReportSteps';

const pathPrefix = '/reportProblem/';

export function getReportStepPath(step: ReportStep): string {
	return `${pathPrefix}${step}`;
}

export function useDraftPath(step?: ReportStep): string | undefined {
	const currentStep = useCurrentStep();

	const stepName = step ?? currentStep;
	if (!stepName) {
		return undefined;
	}

	return getReportStepPath(stepName);
}
